const Routes = [
  {
    path: '/merchants',
    name: 'Merchants',
    component: () => import('@/app/merchants/TheMerchants'),
    redirect: '/merchants/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: () => import('@/app/merchants/views/Index')
      },
      {
        path: 'merchant',
        name: 'Merchant',
        component: () => import('@/app/merchants/views/Merchant')
      }
    ]
  }
]
export default Routes



// WEBPACK FOOTER //
// ./src/app/merchants/Routes.js